/**
 * @generated SignedSource<<816ae12cd025d442bb2da96ac88e9f25>>
 * @relayHash 76b2ec03249c0e794ba6f7ed0c8cd574
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e02c9b518f9f80e92468155ffd88adf264c9bc61ab05cd53c39c9a2f8ace6e94

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type team_teamSearchQuery$variables = {
  id: string;
  organisationId: string;
  sessionId: string;
  siteId: string;
};
export type team_teamSearchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"team_issueFieldTeamEditviewFull_TeamEditViewWithFieldOptionsFragment_fieldOptionsFragmentRef">;
};
export type team_teamSearchQuery = {
  response: team_teamSearchQuery$data;
  variables: team_teamSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organisationId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteId"
},
v4 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v5 = {
  "kind": "Variable",
  "name": "organisationId",
  "variableName": "organisationId"
},
v6 = {
  "kind": "Variable",
  "name": "sessionId",
  "variableName": "sessionId"
},
v7 = {
  "kind": "Variable",
  "name": "siteId",
  "variableName": "siteId"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  },
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "searchBy",
    "value": ""
  },
  (v6/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "team_teamSearchQuery",
    "selections": [
      {
        "args": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "team_issueFieldTeamEditviewFull_TeamEditViewWithFieldOptionsFragment_fieldOptionsFragmentRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "team_teamSearchQuery",
    "selections": [
      {
        "args": [
          (v4/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v9/*: any*/),
                "concreteType": "JiraTeamViewConnection",
                "kind": "LinkedField",
                "name": "teams",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraTeamViewEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraTeamView",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": [
                              (v7/*: any*/)
                            ],
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "fullTeam",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": "name",
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "alias": "avatarUrl",
                                "kind": "ScalarField",
                                "name": "smallAvatarImageUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isVerified"
                              }
                            ]
                          },
                          (v8/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v9/*: any*/),
                "filters": [
                  "searchBy",
                  "organisationId",
                  "sessionId"
                ],
                "handle": "connection",
                "key": "team_issueFieldTeamEditviewFull_teams",
                "kind": "LinkedHandle",
                "name": "teams"
              }
            ],
            "type": "JiraTeamViewField"
          },
          (v10/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "e02c9b518f9f80e92468155ffd88adf264c9bc61ab05cd53c39c9a2f8ace6e94",
    "metadata": {},
    "name": "team_teamSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "af79479c22c0600bab1c8420e6af270e";

export default node;
